export const utilityColors = {
  utilityBackground: '#E6EAEF',
  utilityInformationBackground: '#E6EAEF',
  utilityDivider: '#E6EAEF',
  utilityText: '#02315B',
  utilityWhite: '#FFF',
} as const;
